/**
 * Frontend helper pre stĺpec Nasledujúci krok – preferuje BE pole workflow_next_step_label.
 */
import { uiT } from './uiTranslate';

const PHASE_LABEL_KEYS = Object.freeze({
  approval: 'Workflow.NextStep.Approval',
  execution: 'Workflow.NextStep.Execution',
  inspection: 'Workflow.NextStep.Inspection',
});

const SPECIAL_LABEL_KEYS = Object.freeze({
  quoteFollowup: 'Workflow.NextStep.QuoteFollowup',
  acquisitionEvaluation: 'Workflow.NextStep.AcquisitionEvaluation',
});

// RAW multilingual BE match lexicon (not UI chrome)
const KNOWN_PHASE_LABELS = Object.freeze([
  'Schválenie', 'Approval', 'Genehmigung',
  'Vykonanie', 'Execution', 'Ausführung',
  'Kontrola', 'Inspection', 'Kontrolle',
]);

const EXECUTION_GENERIC_LABELS = Object.freeze([
  'Vykonanie', 'Execution', 'Ausführung',
]);

// RAW multilingual BE match lexicon (not UI chrome)
const KNOWN_SPECIAL_LABELS = Object.freeze({
  quoteFollowup: ['Dosledovanie', 'Follow-up', 'Nachverfolgung', 'Rozhodnutie', 'Decision', 'Entscheidung', 'KDecision'],
  acquisitionEvaluation: ['Vyhodnotenie', 'Evaluation', 'Auswertung'],
});

function translateKey(key, t) {
  if (typeof t === 'function') {
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  return uiT(key);
}

function resolveKnownSpecialLabel(fromResolver, rowData, t) {
  const ticketType = String(rowData?.type ?? '').trim();
  if (KNOWN_SPECIAL_LABELS.quoteFollowup.includes(fromResolver) || (ticketType === 'quote_request' && fromResolver === '')) {
    return translateKey(SPECIAL_LABEL_KEYS.quoteFollowup, t);
  }
  if (KNOWN_SPECIAL_LABELS.acquisitionEvaluation.includes(fromResolver) || (ticketType === 'acquisition' && fromResolver === '')) {
    return translateKey(SPECIAL_LABEL_KEYS.acquisitionEvaluation, t);
  }
  return null;
}

export function resolveWorkflowNextStepListLabel(rowData, t) {
  const phase = String(rowData?.workflow_next_step_phase ?? '').trim();
  const fromResolver = String(rowData?.workflow_next_step_label ?? '').trim();
  const stepLabel = String(rowData?.execution_crm_step_label ?? '').trim();
  if (phase === 'inspection') {
    const specialLabel = resolveKnownSpecialLabel(fromResolver, rowData, t);
    if (specialLabel) return specialLabel;
  }
  if (
    stepLabel
    && (phase === 'execution' || phase === '')
    && (!fromResolver || EXECUTION_GENERIC_LABELS.includes(fromResolver))
  ) {
    return stepLabel;
  }
  if (phase && PHASE_LABEL_KEYS[phase] && (!fromResolver || KNOWN_PHASE_LABELS.includes(fromResolver))) {
    return translateKey(PHASE_LABEL_KEYS[phase], t);
  }
  if (fromResolver) return fromResolver;
  if (stepLabel) return stepLabel;
  if (phase && PHASE_LABEL_KEYS[phase]) {
    return translateKey(PHASE_LABEL_KEYS[phase], t);
  }
  return '';
}

export const WORKFLOW_NEXT_STEP_PHASES = Object.freeze(['approval', 'execution', 'inspection']);
